export enum FileData_PDFSettings_ViewMode {
  /** NONE - No PDF view */
  NONE = "NONE",
  /** FULL - Full PDF view */
  FULL = "FULL",
  /** MINI - Mini PDF view */
  MINI = "MINI",
  UNRECOGNIZED = "UNRECOGNIZED",
}